export function mapSelectedValues(values, queryValues) {
    return values.map((value) => {
        return {
            ...value,
            selected: !!value.uuid && queryValues.includes(value.uuid),
        };
    });
}
export function mapSearchCategoriesFromQueryParams(categories, queryCategories) {
    return categories.map((category) => {
        return {
            ...category,
            selected: !!category.uuid && queryCategories.includes(category.uuid),
        };
    });
}
export function createBrandsQueryParamsString(brands) {
    return brands
        .filter((brand) => brand.selected)
        .reduce((queryParams, current) => {
        return queryParams
            ? `${queryParams}&brandUuids=${current.uuid}`
            : `brandUuids=${current.uuid}`;
    }, '');
}
export function arrayToQueryString(arr, key) {
    if (!arr || arr.length === 0)
        return '';
    return arr.map(value => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
export function createCategoriesQueryParamsString(categories) {
    return categories
        .filter((category) => category.selected)
        .reduce((queryParams, current) => {
        return queryParams
            ? `${queryParams}&categoriesUuids=${current.uuid}`
            : `categoriesUuids=${current.uuid}`;
    }, '');
}
export function createUuidsArray(items) {
    let itemsWithChildren = items.map((item) => {
        if (item.selected) {
            return item.uuid;
        }
        else if (item?.children && item?.children.length) {
            let childrenUuid = [];
            for (let i = 0; i < item.children.length; i++) {
                if (item.children[i].selected) {
                    childrenUuid.push(item.children[i].uuid);
                }
            }
            if (childrenUuid.length) {
                return childrenUuid;
            }
            return;
        }
    });
    let uniqItems = [...new Set(itemsWithChildren.flat())];
    return uniqItems.filter(Boolean);
}
export function mapSearchCategories(categories, selectedCategory) {
    if (selectedCategory === undefined) {
        return categories.map((category) => {
            return {
                ...category,
                selected: false,
            };
        });
    }
    else {
        return categories.map((category) => {
            if (category.selected && selectedCategory.uuid === category.uuid) {
                return {
                    ...category,
                    selected: false,
                };
            }
            else {
                let subCategories = [];
                if (category?.children && category?.children.length > 0) {
                    subCategories = category?.children.map((categoryChildren) => {
                        return {
                            ...categoryChildren,
                            selected: selectedCategory.uuid === categoryChildren.uuid,
                        };
                    });
                }
                category.children = subCategories;
                return {
                    ...category,
                    selected: selectedCategory.uuid === category.uuid,
                };
            }
        });
    }
}
